import { CURRENCY } from 'src/types';

export enum CHARGE_TYPE {
    INVOICE = 'invoice',
    DEBIT = 'debit',
    CREDIT = 'credit',
}

export enum CHARGE_CATEGORY {
    ONE_TIME = 'one_time',
    SUB = 'sub',
    VOUCHER = 'voucher',
    DISCOUNT = 'discount',
}

export enum CHARGE_STATUS {
    PENDING = 'pending',
    INVOICED = 'invoiced',
    VOIDED = 'voided',
    REFUNDED = 'refunded',
}

export type Charge = {
    id: string;
    subscription_item: {
        id: string;
        subscription: {
            id: string;
            reference: string;
        };
        service_plan_item: {
            id: string;
            name: string;
        };
    };
    financial_document: {
        id: string;
        number: string | null;
    } | null;
    created_at: string;
    modified_at: string;
    name: string;
    type: CHARGE_TYPE;
    category: CHARGE_CATEGORY;
    currency: CURRENCY;
    amount: number;
    amount_with_tax: number;
    tax_amount: number;
    status: CHARGE_STATUS;
    external_product_id: string | null;
    external_source_id: string | null;
    billing_period_start: string | null;
    billing_period_end: string | null;
    charge: number | null;
    tenant: string | null;
    /*
     * Everything below is written by the billing engine and ignored if sent on a write - it records
     * how the amount was derived.
     */
    /** Unit price actually used, in minor units. */
    unit_amount: number | null;
    quantity: number | null;
    /** The reference rate value used, when the charge came from an indexed policy. */
    reference_rate_value: string | null;
    /** A decimal fraction - "0.5" means 50%. */
    rate_multiplier: string | null;
    tax_reason: string | null;
    /**
     * A ready-to-render derivation, e.g. `4 x 2.50 EUR = 10.00 EUR`. Built server-side so the
     * wording can change without a frontend release - render it verbatim, never parse it. Null for
     * credit charges and for charges predating the feature.
     */
    price_explanation: string | null;
};
